import React from 'react';
import { useTranslation } from 'react-i18next';
import { WidthIcon } from '@radix-ui/react-icons';
import type { PropertyFilters } from './constants';
import { PARKING_TYPE_OPTIONS } from './constants';
import { SectionHeader, FieldLabel, ChipBtn } from './parts';

interface Props {
  filters: PropertyFilters;
  toggleInArray: (field: keyof PropertyFilters, value: string) => void;
}

/**
 * Checks whether an array-valued filter field already includes a value.
 */
const has = (filters: PropertyFilters, field: keyof PropertyFilters, value: string) =>
  ((filters[field] as string[] | undefined) || []).includes(value);

export const FilterSectionParking: React.FC<Props> = ({ filters, toggleInArray }) => {
  const { t } = useTranslation('features/properties');
  return (
    <div>
      <SectionHeader icon={<WidthIcon width={14} height={14} />} title={t('filterPanel.parkingSection')} />
      <FieldLabel>{t('filterPanel.parkingType')}</FieldLabel>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-1)' }}>
        {PARKING_TYPE_OPTIONS.map((token) => (
          <ChipBtn
            key={token}
            value={t(`form.options.parkingType.${token}`, { defaultValue: token })}
            active={has(filters, 'parkingType', token)}
            onClick={() => toggleInArray('parkingType', token)}
          />
        ))}
      </div>
    </div>
  );
};
